
















































































































import FormaCobro from '@/models/FormaCobro';
import Campo from '@/models/Campo';
export default {
	name: 'CuentaCorriente',
	inject: ['responsive'],
	components: {
		//Currency,
	},
	data() {
		return {
			//campos: [],
			activeName: 0,
			titulo: [],
		};
	},
	watch: {
		formularioCobro(value) {
			if (value.forma.length === 1 && value.forma[0].campos.length === 1 && value.forma[0].campos[0].label === '') this.titulo = [];
		},
	},

	computed: {
		formasCobro() {
			return this.$store.state.recibos.formasCobro;
		},
		formularioCobro() {
			return this.$store.state.recibos.formularioCobro;
		},
		totalApagar() {
			return this.$store.state.recibos.totalApagar;
		},
	},
	filters: {},
	methods: {
		selectAll(e) {
			e.target.select();
		},
		uploadFile(e) {
			this.$store.dispatch('saveFile', e.target.files[0]);
		},
		resetFile(index) {
			let input;
			input = document.getElementById('file' + index);
			input.value = '';
			this.$store.dispatch('resetFile', index);
		},
		onChangeForma(select: number, index: number) {
			this.formasCobro.forEach((fp: FormaCobro) => {
				if (fp.codcon == select) {
					this.formularioCobro.forma[index].campos = [];
					let asd: object[] = [];
					fp.campos.forEach(campo => {
						asd.push({ key: Date.now(), ...campo });
					});
					// agrego un nuevo campo al formulario, de ésta forma sino repite el objeto
					this.formularioCobro.forma[index].campos = asd;
				}
			});
			this.$store.dispatch('calculaTotal', this.formularioCobro.forma);
		},
		/*valideteForm() {
			this.formularioCobro.forma[0].campos.forEach(element => {
				let input;
				input = document.getElementById('file0');
				if (element.inputtype === 'file' && !input.value) {
					this.$message({
						message: 'El archivo es requerido',
						showClose: true,
						type: 'error',
						duration: 0,
					});
					return false;
				}
				console.log('element', element);
				if (element.required && !element.value && element.inputtype !== 'file') {
					this.$message({
						message: 'El campo ' + element.label + ' es requerido',
						showClose: true,
						type: 'error',
						duration: 0,
					});
					return false;
				}
				return true;
			});
		},*/
		onSubmit() {
			this.$refs['formularioCobro'].validate(valid => {
				console.log('ASDQWAEWEQQWEQWE', valid);

				if (valid) {
					this.activeName = this.activeName + 1;
					this.formularioCobro.forma.push({
						key: Date.now(),
						id: Date.now(),
						metodo: '',
						codcon: '',
						campos: [],
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		removeFDP(item: []) {
			this.activeName = this.activeName - 1;
			var index = this.formularioCobro.forma.indexOf(item);
			this.$store.dispatch('resetFile', index);
			this.titulo[index] = '';
			if (index !== -1) this.formularioCobro.forma.splice(index, 1);
			this.$store.dispatch('calculaTotal', this.formularioCobro.forma);
		},
		pressKey(event, medio, index) {
			let key = event.key;
			if (key === 'Unidentified' || key === '.') {
				key = ',';
				medio.value += key;
			}
		},
		onBlur(medio, index) {
			const input = document.querySelector(`#currency_${index}`);
			function formatNumber(n) {
				// format number 1000000 to 1.234.567
				return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
			}
			// appends $ to value, validates decimal side
			// and puts cursor back in right position.

			// get input value
			var input_val = medio.value;

			// don't validate empty input
			if (!input_val || input_val === '') return;

			// original length
			var original_len = input_val.length;

			// initial caret position
			// var caret_pos = medio.prop('selectionStart');

			// check for decimal
			if (input_val.indexOf(',') >= 0) {
				// get position of first decimal
				// this prevents multiple decimals from
				// being entered
				var decimal_pos = input_val.indexOf(',');

				// split number by decimal point
				var left_side = input_val.substring(0, decimal_pos);
				var right_side = input_val.substring(decimal_pos);

				// add commas to left side of number
				left_side = formatNumber(left_side);

				// validate right side
				right_side = formatNumber(right_side);

				// On blur make sure 2 numbers after decimal
				// if (blur === 'blur') {
				// 	right_side += '00';
				// }

				// Limit decimal to only 2 digits
				right_side = right_side.substring(0, 2);

				// join number by .
				input_val = '$' + left_side + ',' + right_side;
			} else {
				// no decimal entered
				// add commas to number
				// remove all non-digits
				input_val = formatNumber(input_val);
				input_val = '$' + input_val;

				// final formatting
				// if (blur === 'blur') {
				// 	input_val += ',00';
				// }
			}

			//if (input_val.indexOf('.') >= 0 ) input_val = input_val.replace('.', ',');

			// send updated string to input
			console.log('input_val', input_val);
			medio.value = input_val;

			// put caret back in the right position
			// var updated_len = input_val.length;
			// caret_pos = updated_len - original_len + caret_pos;
			// input.setSelectionRange(caret_pos, caret_pos);

			if (medio.suma) {
				this.titulo[index] = '';
				this.titulo[index] = `Método de cobro  ${index + 1}: (${medio.label}) ${medio.value}`;
				this.$store.dispatch('calculaTotal', this.formularioCobro.forma);
			}
		},
	},
	mounted() {
		this.$store.dispatch('callFormasCobro');
		this.$store.dispatch('callFormularioCobro');
	},
};
